export const NotFoundScreen = () => <div>Página não encontrada</div>;
